import { NextPageWithLayout } from "types";
import { useRouter } from "next/router";
import { useEffect } from "react";
import BrowseAll from "./browse";


const Home: NextPageWithLayout = () => {
  const router = useRouter();
  useEffect(() => {
    router.replace("/browse");
  }, [router]);

  return (
    <div className="w-full">
      <BrowseAll isStartPage={true} />
    </div>
  );
};

Home.layout = {
  transparentHeader: true,
};

export default Home;
